export * from './components';
export * from './directives';
export { default as colors } from './util/colors';
export { default } from './framework';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/index.js